function changePropery() {
  fetch('/cart?view=json', {
    method: 'GET',
    headers: {
      'Content-Type': 'text/plain'
    }
  }).then(function(response) {
    if (response.ok) {
      return response.text();
    }
  }).then(function(response) {
    if (!!response) {
      let newEl = document.createElement('div');
      newEl.innerHTML = response;
      if (!!newEl.querySelectorAll(".discounted-elements")) {
        var scriptDiscounts = newEl.querySelectorAll(".discounted-elements");
        scriptDiscounts.forEach(scriptDiscount => {
          if (!!scriptDiscount.querySelector('.discounted-quantity-element')) {
            let scriptDiscountQty = scriptDiscount.querySelector('.discounted-quantity-element')
            let discountedQuantity = scriptDiscountQty.getAttribute('data-discounted-quantity');
            let discountedId = scriptDiscountQty.getAttribute('data-discounted-id');
            let discountedPropertiesValue = scriptDiscountQty.getAttribute('data-properties-value');
            mergePropertiesAndUpdateLineItem({"_discounted_quantity": discountedPropertiesValue}, discountedQuantity, discountedId);
          }
          if (!!scriptDiscount.querySelector('.discounted-threshold-element')) {
            let scriptDiscountThreshold = scriptDiscount.querySelector('.discounted-threshold-element')
            let discountedThresholdQuantity = scriptDiscountThreshold.getAttribute('data-discounted-quantity');
            let discountedThresholdId = scriptDiscountThreshold.getAttribute('data-discounted-id');
            let discountedThresholdPropertiesValue = scriptDiscountThreshold.getAttribute('data-properties-value');
            mergePropertiesAndUpdateLineItem({"_product_discount_threshold": discountedThresholdPropertiesValue}, discountedThresholdQuantity, discountedThresholdId);
          }
        });
      }
    }
  });
}

function mergePropertiesAndUpdateLineItem(newProperties, discountedQuantity, discountedId) {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(response => response.json())
    .then(cart => {
      const lineItem = cart.items.find(item => item.id === parseInt(discountedId));
      if (lineItem) {
        const mergedProperties = { ...lineItem.properties, ...newProperties };
        updateLineItemProperties(mergedProperties, discountedQuantity, discountedId);
      }
    }).catch((error) => {
      console.log('Error:', error);
    });
}

function updateLineItemProperties(properties, quantity, id) {
  var propertyChange = {
    id: id,
    quantity: quantity,
    properties: properties
  };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(propertyChange)
  }).then(response => response.json())
    .then(response => {
      console.log('Property updated');
    }).catch((error) => {
      console.log('Error:', error);
    });
}

document.addEventListener('cart:rerendered', function(event) {
  changePropery();
});
document.addEventListener("DOMContentLoaded", function() {
  changePropery();
});